import { axiosPut, del, get, post } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { getFormDataFromJSON, showToast } from "utils"
import {
  addNewUserFailed,
  addNewUserSuccess,
  assignCodeFailed,
  assignCodeSuccess,
  deleteBatchFailed,
  deleteBatchSuccess,
  generateCodeFailed,
  generateCodeSuccess,
  getCodeBatchFailed,
  getCodeBatchSuccess,
  getCodesListFailed,
  getCodesListSuccess,
  hideAssignCodeModal,
  hideCreateUserModal,
  hideReassignCodeModal,
  hideReinstateCodeModal,
  reassignCodeFailed,
  reassignCodeSuccess,
  reinstateCodeFailed,
  reinstateCodeSuccess,
  retryBatchFailed,
  retryBatchSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import {
  ADD_NEW_USER,
  ASSIGN_CODE,
  DELETE_BATCH,
  GENERATE_CODE,
  GET_CODES_LIST,
  GET_CODE_BATCH,
  REASSIGN_CODE,
  REINSTATE_CODE,
  RETRY_BATCH,
} from "./actionTypes"

function* getCodesList({ payload: params }) {
  try {
    const response = yield get(url.CODES_URL, { params })
    yield put(getCodesListSuccess(response))
  } catch (error) {
    yield put(getCodesListFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCodeBatch({ payload: params }) {
  try {
    const response = yield get("/admin/batch")
    yield put(getCodeBatchSuccess(response))
  } catch (error) {
    yield put(getCodeBatchFailed(error))
    showToast("error", error, "Error")
  }
}

function* retryBatch({ payload: params }) {
  try {
    const response = yield post(`/admin/batch/${params?.id}/retry`)
    yield put(retryBatchSuccess(response))
    showToast("success", "Batch reinitialised", "Success")
  } catch (error) {
    yield put(retryBatchFailed(error))
    showToast("error", error, "Error")
  }
}

function* addNewUser({ payload: params }) {
  try {
    const response = yield post(url.REGISTER_URL, getFormDataFromJSON(params))
    yield put(addNewUserSuccess(response))
    showToast("success", "User created", "Success")
    yield put(hideCreateUserModal())
  } catch (error) {
    yield put(addNewUserFailed(error))
    showToast("error", error, "Error")
  }
}

function* assignCode({ payload: params }) {
  try {
    const response = yield axiosPut("/admin/codes/assign", params?.values)
    yield put(assignCodeSuccess(response))
    yield put(hideAssignCodeModal())
    if (response?.error) {
      showToast("error", response?.error, "Error")
    } else {
      if (params?.callback) {
        params?.callback()
      }
      yield showToast("success", "Code assigned", "Success")
    }
  } catch (error) {
    yield put(assignCodeFailed(error))
    yield put(hideAssignCodeModal())
    showToast("error", error, "Error")
  }
}

function* reinstateCode({ payload: params }) {
  try {
    const response = yield axiosPut("/admin/codes/reinstate", params?.values)
    yield put(reinstateCodeSuccess(response))
    yield put(hideReinstateCodeModal())
    if (params?.callback) {
      params?.callback()
    }
    yield showToast("success", "Code reinstated", "Success")
  } catch (error) {
    yield put(reinstateCodeFailed(error))
    yield put(hideReinstateCodeModal())
    showToast("error", error, "Error")
  }
}

function* reassignCode({ payload: params }) {
  try {
    const response = yield axiosPut("/admin/codes/reassign", params?.values)
    yield put(reassignCodeSuccess(response))
    yield put(hideReassignCodeModal())
    if (response?.error) {
      showToast("error", response?.error, "Error")
    } else {
      if (params?.callback) {
        params?.callback()
      }
      yield showToast("success", "Code reassigned", "Success")
    }
  } catch (error) {
    yield put(reassignCodeFailed(error))
    yield put(hideReassignCodeModal())
    showToast("error", error, "Error")
  }
}

function* generateCode({ payload: params }) {
  try {
    const response = yield post("/admin/batch", params)
    yield put(generateCodeSuccess(response))
    showToast("success", "Batch created", "Success")
  } catch (error) {
    yield put(generateCodeFailed(error))
    showToast("error", error, "Error")
  }
}

function* deleteBatch({ payload: params }) {
  try {
    const response = yield del(`/admin/batch/${params?.id}`)
    yield put(deleteBatchSuccess(response))
    showToast("success", "Batch deleted", "Success")
  } catch (error) {
    yield put(deleteBatchFailed(error))
    showToast("error", error, "Error")
  }
}

function* codesSaga() {
  yield takeEvery(GET_CODES_LIST, getCodesList)
  yield takeEvery(GET_CODE_BATCH, getCodeBatch)
  yield takeEvery(RETRY_BATCH, retryBatch)
  yield takeEvery(ADD_NEW_USER, addNewUser)
  yield takeEvery(ASSIGN_CODE, assignCode)
  yield takeEvery(REINSTATE_CODE, reinstateCode)
  yield takeEvery(REASSIGN_CODE, reassignCode)
  yield takeEvery(GENERATE_CODE, generateCode)
  yield takeEvery(DELETE_BATCH, deleteBatch)
}

export default codesSaga
